
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AccountLedgerGrid extends _Ext.GridBase<AccountLedgerRow, any> {
        protected getColumnsKey() { return 'OMS.AccountLedger'; }
        protected getDialogType() { return AccountLedgerDialog; }
        protected getIdProperty() { return AccountLedgerRow.idProperty; }
        protected getInsertPermission() { return AccountLedgerRow.insertPermission; }
        protected getLocalTextPrefix() { return AccountLedgerRow.localTextPrefix; }
        protected getService() { return AccountLedgerService.baseUrl; }

        constructor(container: JQuery, options) {
            super(container, options);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}